import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import s from "./Background.module.css";
export const PHOTO_CATEGORIES = [
    { id: "tokyo", label: "Tokyo", query: "tokyo japan neon street night" },
    { id: "shibuya", label: "Shibuya", query: "shibuya crossing tokyo rain" },
    { id: "seoul", label: "Seoul", query: "seoul korea city night street" },
    { id: "hongkong", label: "HK", query: "hong kong city night skyline" },
    { id: "newyork", label: "New York", query: "new york city manhattan street night" },
    { id: "chicago", label: "Chicago", query: "chicago city urban architecture" },
    { id: "urbannigh", label: "Urban", query: "urban city street night rain neon" },
];
const PEXELS_KEY = import.meta.env.VITE_PEXELS_API_KEY;
const CELL_PATTERN = ["a", "", "b", "d", "", "c", "", "c", "", "a", "b", "", "b", "d", "a", "", "c", "d", "d", "a", "", "b", "", "a"];
const cellClass = {
    a: `${s.bpCell} ${s.bpCellA}`,
    b: `${s.bpCell} ${s.bpCellB}`,
    c: `${s.bpCell} ${s.bpCellC}`,
    d: `${s.bpCell} ${s.bpCellD}`,
    "": s.bpCell,
};
export default function Background({ category, refreshSeed }) {
    const [photoUrl, setPhotoUrl] = useState(null);
    const [loaded, setLoaded] = useState(false);
    useEffect(() => {
        if (!PEXELS_KEY)
            return;
        setLoaded(false);
        const cat = PHOTO_CATEGORIES.find((c) => c.id === category) ?? PHOTO_CATEGORIES[0];
        const page = (refreshSeed % 8) + 1;
        fetch(`https://api.pexels.com/v1/search?query=${encodeURIComponent(cat.query)}&per_page=15&page=${page}&orientation=portrait`, { headers: { Authorization: PEXELS_KEY } })
            .then((r) => r.json())
            .then((data) => {
            const photos = data.photos ?? [];
            if (photos.length) {
                const pick = photos[Math.floor(Math.random() * photos.length)];
                setPhotoUrl(pick.src.large);
            }
        })
            .catch(() => { });
    }, [category, refreshSeed]);
    return (_jsxs("div", { className: s.bg, children: [_jsx("div", { className: s.bgPlaceholder, children: CELL_PATTERN.map((type, i) => (_jsx("div", { className: cellClass[type] }, i))) }), photoUrl && (_jsx("div", { className: `${s.poster} ${loaded ? s.posterVisible : ""}`, children: _jsx("img", { className: s.posterImg, src: photoUrl, alt: "", onLoad: () => setLoaded(true) }) })), _jsx("div", { className: s.bgOverlay })] }));
}
//# sourceMappingURL=Background.js.map